<template>
  <a class="item">
    <div class="content">
      <pre>{{ section }}</pre>
      <div class="ui grid">
        <div class="eight wide column">
          <div
            class="ui right floated basic mini icon button"
            @click="course_record(section)"
            :data-tooltip="$t('print record')"
          >
            <i class="print icon"></i>
          </div>
          <div class="ui small header">
            {{ section.crs_course.name }} | {{ $t("section") }}
            {{ section.name }}
            <small> - {{ section.setup.schedule }}</small>
          </div>
          <div class="ui compact list" style="padding-top: 0">
            <phase
              :phase="itm"
              :section="section"
              v-for="(itm, idx) in section.setup.weighting"
              :key="idx"
              @phase_confirmed="$emit('phase_confirmed')"
            />
          </div>
        </div>
        <div class="eight wide column">
          <h5 class="ui header" v-if="section.crs_records.length">
            {{ $t("generated records") }}
          </h5>
          <div class="ui link list" v-if="section.crs_records.length">
            <div
              class="item"
              v-for="(rcrd, idx) in section.crs_records"
              :key="idx"
              @click="reprint(rcrd)"
            >
              <i class="file signature icon"></i>
              <div class="content">
                <a class="header">
                  {{ rcrd.group }}
                  <small class="right floated"
                    >{{
                      rcrd.create_date
                        | formatDate(enterprise_setup.detailed_date_format)
                    }}
                  </small>
                  <div class="description">
                    {{ rcrd | record_name }}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="ui divider"></div> -->
    </div>
  </a>
</template>

<script>
import Phase from "./Phase.vue";
import filters from "@/filters";
import { enterprise_setup } from "@/utils";

filters.record_name = (record) => {
  let stages = record.stages
    .map((st) => {
      return st.name;
    })
    .join(", ");
  return stages;
};

export default {
  name: "",
  props: { section: Object },
  components: { Phase },
  filters: filters,
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    course_record(section) {
      let vm = this;
      vm.$emit("emit_show_record", section);
    },
    reprint(record) {
      let vm = this;
      vm.$emit("emit_show_reprint", record);
    },
  },
};
</script>
